import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { Wrapper, Paragraph } from '../../../../shared/ModalComponents';
import { StyledTitle, ButtonGroup } from './StyledComponents';
import DatePicker from '../../../../shared/DatePicker';
import { Button } from '../../../../shared/FormStyles/Button';

const StyledGroup = styled(ButtonGroup)`
  margin-top: 24px;
`;

const FollowUpDateInput = ({ value, onCancel, onConfirm, handleChange }) => {
  const { t } = useTranslation('send');

  return (
    <Wrapper>
      <StyledTitle>{t('followUp.sendOnLabel')}</StyledTitle>
      <Paragraph>{t('followUp.dateInputText')}</Paragraph>
      <DatePicker
        value={value}
        mode="single"
        minDate="today"
        onChange={handleChange}
      />
      <StyledGroup>
        <Button variant="tertiary" onClick={onCancel}>
          {t('followUp.cancelButton')}
        </Button>
        <Button variant="containedBlue" ml="8px" onClick={onConfirm}>
          {t('followUp.saveButton')}
        </Button>
      </StyledGroup>
    </Wrapper>
  );
};

export default FollowUpDateInput;
